import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import * as styles from './Snackbar.module.css';

interface SnackbarProps {
  message?: React.ReactNode;
  visible: boolean;
  duration?: number;
  variant?: 'tooltip' | 'banner';
  type?: 'info' | 'success' | 'error';
  onHide?: () => void;
}

function Snackbar({
  message,
  visible,
  duration = 5000,
  variant = 'tooltip',
  type,
  onHide = () => {},
}: SnackbarProps) {
  const resolvedType = type ?? (variant === 'tooltip' ? 'info' : 'success');
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!visible) return;
    setShow(true);
    const timer = setTimeout(() => {
      setShow(false);
      onHide();
    }, duration);
    return () => clearTimeout(timer);
  }, [visible]);

  if (!show) return null;

  return (
    <div className={cx(styles.snackbar, styles[variant], styles[resolvedType])}>
      {message}
    </div>
  );
}

export default Snackbar;
